module.exports = __webpack_public_path__ + "static/instagram_pink-7fac9734ea069e219077aae40f1f23b8.png";